export const environment = {
  PRODUCTION: "true",
  API_URL: 'https://v9yx2i2epd.execute-api.eu-west-1.amazonaws.com/production',
  COOKIE_DOMAIN: '.revogo.fr',
  AWS_REGION: 'eu-west-1',
  COGNITO_USER_POOL_ID: 'eu-west-1_SURE8jPA9',
  COGNITO_CLIENT_ID: '74p98mue8fl7k5idgtu774chgr',
  COGNITO_POOL_URL: 'https://revogo.auth.eu-west-1.amazoncognito.com'
};
